export enum ColorSwitchOptions {
  Manually = 0,
  Automatically = 2,
}
